import cookie from 'react-cookies';
import cookieParser from 'cookie';
import dayjs from 'dayjs';
import { IncomingMessage, ServerResponse } from 'http';

import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

import { COOKIE_DOMAIN } from '~/src/constants';

export interface IServResponseWithCookie extends ServerResponse {
    cookie: (a: string, b: string | number, c: Record<string, unknown>) => void,
}

/**
 * Получает cookie на сервере или на клиенте (req - требуется для сервера)
 * @deprecated
 */
export const getCookie = (cookieName: string, req?: IncomingMessage): string | undefined => {
    if (isServerSide()) {
        if (!req || !req.headers || !req.headers.cookie) {
            return undefined;
        }
        const parsedCookie = cookieParser.parse(req.headers.cookie);
        return  parsedCookie[cookieName];
    } else {
        const loadCookie = cookie.load(cookieName, true);

        return loadCookie || undefined;
    }
};

export const removeCookie = (cookieName: string, res?: ServerResponse) => {
    const resWithCookie = res as IServResponseWithCookie;

    if (isServerSide()) {
        resWithCookie?.cookie(cookieName, '', {
            expires: dayjs('1970-1-1').toDate(),
            domain: COOKIE_DOMAIN,
            path: '/',
        });
    } else {
        cookie.remove(cookieName);
    }
};
